import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

console.log("teamslider.js loaded");

// -----------------------------------------------------------------------------
// Initialise Team Sliders – mirrors the approach used by slider_c739.js
// -----------------------------------------------------------------------------

$('.teamslider_swiper').each(function () {

    var $slider     = $(this);                       // .teamslider_swiper (outer Swiper element)
    var $scrollbar  = $slider.find('.swiper-scrollbar');

    // -------------------------------------------------------------------------
    // Slides-per-view defaults with optional data-attribute overrides
    // -------------------------------------------------------------------------
    var slidesPerViewMobile  = 1.2; // < 768px
    var slidesPerViewTablet  = 2;   // ≥ 768px
    var slidesPerViewDesktop = 2;   // ≥ 1260px

    if ($slider.data('slides_perview_mobile')) {
        var m = parseFloat($slider.data('slides_perview_mobile'));
        if (m > 0) { slidesPerViewMobile = m; }
    }
    if ($slider.data('slides_perview_tablet')) {
        var t = parseFloat($slider.data('slides_perview_tablet'));
        if (t > 0) { slidesPerViewTablet = t; }
    }
    if ($slider.data('slides_perview_desktop')) {
        var d = parseFloat($slider.data('slides_perview_desktop'));
        if (d > 0) { slidesPerViewDesktop = d; }
    }

    // -------------------------------------------------------------------------
    // Start hidden (opacity 0) and fade in once Swiper has initialised
    // -------------------------------------------------------------------------
    $slider.css('opacity', 0);

    // -------------------------------------------------------------------------
    // Build Swiper instance
    // -------------------------------------------------------------------------
    var swiper = new Swiper($slider[0], {
        slidesPerView: slidesPerViewMobile,
        spaceBetween: 20,
        grabCursor: true,
        scrollbar: {
            el: $scrollbar[0],
            hide: false,
        },
        // Fade the slider in when Swiper is ready
        on: {
            init: function () {
                // jQuery fade-in for a smooth reveal once everything is wired up
                $slider.animate({ opacity: 1 }, 400);
            }
        },
        breakpoints: {
            768:  { slidesPerView: slidesPerViewTablet  },
            1260: { slidesPerView: slidesPerViewDesktop }
        }
    });

    // Simple fallback autoplay – advances every 5 seconds.
    setInterval(function () {
        if (swiper && !swiper.destroyed) {
            swiper.slideNext();
        }
    }, 5000);
});